export default __webpack_public_path__ + "static/media/bandan_query.2366bc0c.png";